import config from '../../../config'
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers'
import { appName } from '../appConfig'

const base = `${appName}/clientReview`

export const clientReviewService = {
  getAll,
  getByClient,
  getBySlug,
  create,
  update,
  remove,
}

function getAll(signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/all`, opts, signal).then(handleResponse)
}

// clientSlug — reviews are client-level, not case-level, since PR4.
function getByClient(clientSlug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/by-client/${encodeURIComponent(clientSlug)}`, opts, signal).then(handleResponse)
}

function getBySlug(slug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/${slug}`, opts, signal).then(handleResponse)
}

function create(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}`, opts, signal).then(handleResponse)
}

function update(slug, payload, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${slug}`, opts, signal).then(handleResponse)
}

function remove(slug, signal) {
  const opts = {
    method:  'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${slug}`, opts, signal).then(handleResponse)
}
